import { PLAYBACK_RATE_DEFAULT } from 'constants/params';
import { Rotate } from 'services/file.service';
import { ConfigFlags } from 'services/clip.service';
import { useAppDispatch, useAppStore } from 'store/store-hooks';
import { Clip, handleClipConfig } from 'components/app/editor/_mediator/editor.slice';
import { SPEED_SLOW, SPEED_FAST } from './_config-panel.params';

export const useClipConfig = (clipData?: Clip) => {
  const dispatch = useAppDispatch();
  const store = useAppStore();

  const _handleFlags = (action: (clipData: ConfigFlags[]) => ConfigFlags[]) => {
    if (!clipData) return;
    const flags = action(clipData.config.flags);
    dispatch(
      handleClipConfig({
        data: { clipId: clipData.clipId, config: { flags } },
        backupParams: { title: 'Clip Configs' },
      })
    );
  };

  const handleConfigs = (config: ConfigFlags) => {
    _handleFlags((configs) => {
      const res = configs.includes(config) ? configs.filter((conf) => conf !== config) : [...configs, config];
      return res;
    });
  };
  //

  const handleOrder = (order: ConfigFlags.orderFirst | ConfigFlags.orderLast) =>
    _handleFlags((configs) => {
      if (configs.includes(order)) return configs.filter((conf) => conf !== order);
      const res: ConfigFlags[] = configs.filter(
        (conf) => conf !== ConfigFlags.orderFirst && conf !== ConfigFlags.orderLast
      );
      res.push(order);
      return res;
    });
  //

  const handleSpeed = (speed: typeof SPEED_SLOW | typeof SPEED_FAST) => {
    if (!clipData) return;
    dispatch(
      handleClipConfig({
        data: {
          clipId: clipData.clipId,
          config: { speed: speed === clipData.config.speed ? PLAYBACK_RATE_DEFAULT : speed },
        },
        backupParams: { title: 'Clip Speed' },
      })
    );
  };

  const handleEffects = () => {
    if (!clipData) return;
    const effects = store.getState().editor.effectsAdjustment;
    dispatch(
      handleClipConfig({
        data: { clipId: clipData.clipId, config: { ...effects } },
        backupParams: { title: 'Clip Effects' },
      })
    );
  };

  const handleRotate = (rotate: Rotate | null) => {
    if (!clipData) return;
    switch (rotate) {
      case Rotate.default:
        rotate = null;
        break;
      case null:
        rotate = Rotate.d90;
        break;
      default:
        rotate = rotate + 1;
        if (rotate > Rotate.d270) rotate = Rotate.default;
        break;
    }

    dispatch(
      handleClipConfig({
        data: { clipId: clipData.clipId, config: { rotate } },
        backupParams: { title: 'Clip Rotate' },
      })
    );
  };

  return {
    handleConfigs,
    handleOrder,
    handleSpeed,
    handleEffects,
    handleRotate,
  };
};
